import React from "react";

const testimonials = [
    {
      n: "Ravi Kumar",
      c: "Warangal",
      q: "Started my own mobile shop 2 months after graduating. Now earning ₹45,000/month.",
      role: "Owner · Ravi Mobile Care"
    },
    {
      n: "Priya Sharma",
      c: "Vijayawada",
      q: "The chip-level module changed everything. I can repair boards other technicians reject.",
      role: "Sr. Technician · CellFix"
    },
    {
      n: "Ahmed Khan",
      c: "Hyderabad",
      q: "Hands-on from day one. By day 15 I was already fixing live customer phones.",
      role: "Owner · Khan Mobiles"
    }
  ];

function Testimonials(){
    return(
                <section className="testimonial-section scroll-reveal">

                <div className="testimonial-container scroll-reveal">

                    <div className="testimonial-header scroll-reveal">

                        <div className="testimonial-subtitle scroll-reveal">
                            Student Voices
                        </div>

                        <h2 className="testimonial-title scroll-reveal">
                            Real graduates. Real shops. Real income.
                        </h2>

                    </div>

                    <div className="testimonial-grid scroll-reveal">

                        {testimonials.map((item) => (

                            <div className="testimonial-card scroll-reveal" key={item.n}>

                                <div className="testimonial-stars scroll-reveal">
                                    ★★★★★
                                </div>

                                <p className="testimonial-text scroll-reveal">
                                    "{item.q}"
                                </p>

                                <div className="testimonial-footer scroll-reveal">

                                    <div className="testimonial-avatar scroll-reveal"></div>

                                    <div>

                                        <h4>{item.n}</h4>

                                        <span>
                                            {item.role} · {item.c}
                                        </span>

                                    </div>

                                </div>

                            </div>

                        ))}

                    </div>

                    <div className="testimonial-button scroll-reveal">

                        <a href="/reviews" className="review-btn scroll-reveal">
                            Read all 500+ reviews →
                        </a>

                    </div>

                </div>

                </section>
    )
}
export default Testimonials;
